/**
 * Input Schema of AdminConfig
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import PasswordConfirm from '@/components/PasswordConfirm.vue'
import {AdminConfigInternational} from '@/model/resource/AdminConfigInternational'

export class InputAdminConfigInternationalSchema extends Schema {
  readonly name = 'InputAdminConfigInternational'

  passwordFields = ['panelPassword', 'repeatPanelPassword']

  isSenhaPainelMatch: boolean = false

  readonly fieldSet: FieldSet<AdminConfigInternational> = {
    panelPassword: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        label: this.translateFrom(schema.fieldName),
        type: 'password',
        validation: 'min:8|required',
        required: true,
      },
    }),
    repeatPanelPassword: (schema): FieldComponent => ({
      is: PasswordConfirm,
      bind: {
        value: this.isSenhaPainelMatch,
        label: this.translateFrom(schema.fieldName),
        password: schema.model.panelPassword,
        validation: 'min:8',
        required: Boolean(schema.model.panelPassword),
      },
      on: {
        input: (val: boolean) => (this.isSenhaPainelMatch = val),
      },
    }),
  }
}
